export type TabId = 'cellar' | 'history' | 'stats' | 'profile';

interface Tab {
  id: TabId;
  icon: string;
  label: string;
}

interface BottomTabBarProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
  pendingInvitesCount?: number;
}

const tabs: Tab[] = [
  { id: 'cellar', icon: '🍷', label: 'Cellar' },
  { id: 'history', icon: '📜', label: 'History' },
  { id: 'stats', icon: '📊', label: 'Stats' },
  { id: 'profile', icon: '👤', label: 'Profile' },
];

export function BottomTabBar({ activeTab, onTabChange, pendingInvitesCount = 0 }: BottomTabBarProps) {
  return (
    <div className="tab-bar">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`tab-bar-item ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          <span className="tab-bar-icon" style={{ position: 'relative' }}>
            {tab.icon}
            {tab.id === 'profile' && pendingInvitesCount > 0 && (
              <span
                style={{
                  position: 'absolute',
                  top: '-4px',
                  right: '-8px',
                  background: '#ea580c',
                  color: 'white',
                  fontSize: '10px',
                  fontWeight: '700',
                  width: '16px',
                  height: '16px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {pendingInvitesCount}
              </span>
            )}
          </span>
          <span className="tab-bar-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
}
